import { HStack, Link, Text } from "@chakra-ui/react";

type Props = {
  count: number;
  onEdit: () => void;
  onDelete: () => void;
  onSendEmail?: () => void;
  entity?: string;
};

/** Inline bulk-action bar shown only when at least one row is selected:
 * `N creators selected  ·  Edit  ·  Send email  ·  Delete`. Designed to sit on
 * the same row as the basic/advanced search toggle inside the filter card. */
export default function BulkActionBar({ count, onEdit, onDelete, onSendEmail, entity = "item" }: Props) {
  if (count <= 0) return null;
  const noun = `${entity}${count === 1 ? "" : "s"}`;
  return (
    <HStack spacing={3} fontSize="sm">
      <Text color="gray.600">
        {count} {noun} selected
      </Text>
      <Link
        color="blue.600"
        onClick={(e) => {
          e.preventDefault();
          onEdit();
        }}
        href="#"
      >
        Edit
      </Link>
      {onSendEmail && (
        <Link
          color="blue.600"
          onClick={(e) => {
            e.preventDefault();
            onSendEmail();
          }}
          href="#"
        >
          Send email
        </Link>
      )}
      <Link
        color="red.600"
        onClick={(e) => {
          e.preventDefault();
          onDelete();
        }}
        href="#"
      >
        Delete
      </Link>
    </HStack>
  );
}
